import Vue from 'vue'
import App from './App.vue'
import { store } from './store.js'
import router from './router'
import firebase from 'firebase'
import vuetify from './plugins/vuetify'
import { firestorePlugin } from 'vuefire'
const fb = require('./firebaseConfig.js');


Vue.use(firestorePlugin)

Vue.config.productionTip = false
firebase.auth().onAuthStateChanged(user => {
  store.dispatch('false')   
  if (user) {
      fb.usersCollection.doc(user.uid).get().then(userData=>{
        if(userData.exists){
            if(userData.data().verified==true || userData.data().phoneVerified==true){
              store.dispatch('setEnabledTrue')   
            }
            else{
              store.dispatch('setEnabledFalse')   
            }
        }
        else{
          store.dispatch('setEnabledFalse')   
        }
        new Vue({
          store,
          router,
          vuetify,
          render: h => h(App)
        }).$mount('#app')
        
      })
      store.commit('setCurrentUser', user)
      store.dispatch('fetchUserProfile')
     
  
  } else {

    store.dispatch('clearData')
    new Vue({
      store,
      router,
      vuetify,
      render: h => h(App),
    }).$mount('#app')
  }

  
  
})

